"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgShieldOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M12 22c-.587 0-1.082-.314-1.082-.314-1.804-1.189-3.11-2.56-3.917-3.343C5.502 16.889 4 14.253 4 12V7.006s0-.541.323-1.033c.215-.329.475-.58.78-.755l6-3.007c.3-.14.598-.211.897-.211.299 0 .598.07.896.21l6 3.008c.335.162.608.413.817.755.313.511.287 1.035.287 1.035V12c0 2.23-1.532 4.892-3.003 6.343-.807.795-2.105 2.164-3.897 3.337 0 0-.513.32-1.1.32zm0-2c.44 0 3.143-2.29 3.748-2.926C16.85 15.914 18 14 18 12V7c-3.776-2-5.776-3-6-3-.224 0-2.224 1-6 3v5c0 2 1.127 3.911 2.25 5.074C8.857 17.701 11.56 20 12 20z' }))); };
exports.default = SvgShieldOutline;
//# sourceMappingURL=ShieldOutline.js.map